import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import BibleImageModal from './BibleImageModal';

const BibleImageDisplay = ({ bible }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  if (!bible?.images?.[0]) return null;

  // Remove duplicate images
  const uniqueImages = bible.images.filter((image, index, self) => 
    self.indexOf(image) === index && image && image.trim() !== ''
  );

  // Reset current index if it's out of bounds after deduplication
  const safeCurrentIndex = currentImageIndex >= uniqueImages.length ? 0 : currentImageIndex;
  const currentImage = uniqueImages[safeCurrentIndex];
  const isOptionalImage = safeCurrentIndex > 0; // First image (index 0) is cover, rest are optional

  return (
    <div className="mb-6 space-y-4">
      {/* Main Image Display */}
      <div 
        className="relative overflow-hidden rounded-lg cursor-zoom-in aspect-[3/4] flex items-center justify-center"
        style={{
          backgroundImage: isOptionalImage ? 'none' : 'url(/assets/images/background_image.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: isOptionalImage ? '#f8f9fa' : 'transparent'
        }}
        onClick={handleImageClick}
      >
        <div className={`flex items-center justify-center ${isOptionalImage ? 'w-full h-full' : 'w-full h-full'}`}>
          <Image
            src={currentImage}
            alt={`${bible.title} - ${isOptionalImage ? 'Imagen adicional' : 'Imagen principal'}`}
            className={`${
              isOptionalImage 
                ? 'w-full h-full object-cover rounded' 
                : 'w-[180px] h-[255px] sm:w-[240px] sm:h-[340px] object-cover rounded'
            } transition-transform duration-300 hover:scale-105`}
          />
        </div>
        
        {/* Zoom Indicator */}
        <div className="absolute top-2 right-2 bg-black/50 text-white px-2 py-1 rounded text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          <Icon name="Maximize2" size={16} className="inline mr-1" />
          Ver completa
        </div>
      </div>

      {/* Thumbnail Navigation - Only show if there are multiple unique images */}
      {uniqueImages.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-2">
          {uniqueImages.map((image, index) => (
            <button
              key={index}
              onClick={() => handleThumbnailClick(index)}
              className={`flex-shrink-0 w-16 h-20 rounded border-2 overflow-hidden transition-all duration-200 ${
                safeCurrentIndex === index 
                  ? 'border-primary' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <Image
                src={image}
                alt={`${bible.title} - Miniatura ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}

      {/* Image Modal */}
      <BibleImageModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        image={currentImage}
        title={bible?.title}
      />
    </div>
  );
};

export default BibleImageDisplay;

